export const apipath = process.env.NODE_ENV == 'development' ? 'http://localhost:9999/api' : '/api'

// send
let send = async function(name, req){  
  if (!req) req = {}
  console.log(`req: ${name}`, {name, req})
  req = JSON.stringify({name, req})  
  let request = new Request(apipath, {
    headers: {"Content-Type": "application/json"},
    method: "POST",
    body: req,
  });

  // resp
  const resp = await fetch(request)  
  if (!resp) return {error:{id:'try',code:404}}  

  // json
  let result = await resp.json()
  if (!result) return {error:{id:'try',code:404}}
  
  console.log(`resp: ${name}`, result)  
  return result
}


export { send }
